<template>
  <div class="nc-search">
    <div class="nc-search__inner">
      <mdicon name="magnify" size="18" class="nc-search__icon" />
      <input
        ref="input"
        type="search"
        :value="modelValue"
        :placeholder="placeholder"
        class="nc-search__input"
        :autofocus="autofocus"
        @input="$emit('update:modelValue', $event.target.value)"
        @keyup.enter="$emit('search', modelValue)"
      />
      <button v-if="modelValue" class="nc-search__clear" @click="clear">
        <mdicon name="close-circle" size="16" />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NcSearchBar',
  props: {
    modelValue: { type: String, default: '' },
    placeholder: { type: String, default: 'Zoeken...' },
    autofocus: { type: Boolean, default: false },
  },
  emits: ['update:modelValue', 'search'],
  methods: {
    clear() {
      this.$emit('update:modelValue', '');
      this.$refs.input.focus();
    },
    focus() {
      this.$refs.input.focus();
    },
  },
};
</script>

<style scoped>
.nc-search { padding: 8px 16px; }
.nc-search__inner {
  display: flex;
  align-items: center;
  gap: 8px;
  background: var(--nc-bg-input, #eef2f8);
  border-radius: 10px;
  padding: 0 12px;
  height: 40px;
  border: 1px solid transparent;
  transition: border-color 0.15s ease;
}
.nc-search__inner:focus-within {
  border-color: var(--nc-color-primary, #14b69a);
}
.nc-search__icon { color: var(--nc-text-muted, #92949c); flex-shrink: 0; }
.nc-search__input {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  font-size: 14px;
  font-family: inherit;
  color: var(--nc-text, #1a1a2e);
  min-width: 0;
}
.nc-search__input::placeholder { color: var(--nc-text-placeholder, #b0b3b8); }
.nc-search__input::-webkit-search-cancel-button { display: none; }
.nc-search__clear {
  background: none;
  border: none;
  padding: 2px;
  cursor: pointer;
  color: var(--nc-text-muted, #92949c);
  display: flex;
  align-items: center;
  position: relative;
}
/* Tikgebied minimaal 44px (iOS HIG / WCAG 2.5.5). */
.nc-search__clear::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  min-width: 44px;
  min-height: 44px;
}
</style>
